export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {

    //var holdClass;
    //const el = document.querySelector('#js-logo');

    $('#js-primary-menu').on('click', function(){
      console.log('burger');
      $(this).toggleClass('active');
      $('.nav-primary').toggleClass('active');

      if ($('#js-primary-menu').hasClass('active')) {
        // holdClass = el.classList;
        // alert ('1 ' + holdClass);
        $('.logo').removeClass('black');
        $('.logo').removeClass('small');
        $('.logo').removeClass('hide');
      }

      else {
        // alert ('2 ' + holdClass);
        //el.classList.add(...holdClass);
      }


    });

    $('.nav-primary').on('click', function() {
      $('.burger').removeClass('active');
      $('.nav-primary').removeClass('active');
      $('.logo').addClass('black');
      // $('.logo').addClass('hide');
    });

    // Hiding & revealing logo

    let prevScrollPos = window.pageYOffset;
    const mediaMd = window.matchMedia('(min-width: 768px)');
    const mediaLg = window.matchMedia('(min-width: 1024px)');
    const mediaXl = window.matchMedia('(min-width: 1280px)');
    let minscale = .24;

    function setLogoScale(){
      if (mediaXl.matches) {
        minscale = .24;
      }
      else if (mediaLg.matches) {
        minscale = .32;
      }
      else if (mediaMd.matches) {
        minscale = .50;
      }
      else {
        minscale = .67;
      }
    }

    setLogoScale();
    window.addEventListener('resize', setLogoScale);

    window.onscroll = function() {
      let currentScrollPos = window.pageYOffset;
      let intViewportHeight = window.innerHeight;

      // are we on title card?

      if (currentScrollPos < (intViewportHeight * .65)) {
        let ratio = (currentScrollPos / intViewportHeight);
        let scaleto = (1 - (ratio * 1.5));

        if (scaleto < minscale) {
          scaleto = minscale;
        }

        if ((currentScrollPos > prevScrollPos) && currentScrollPos >= 0) {
          $('.logo').addClass('small');
          $('.logo').css('transform', 'scale(' + scaleto + ')');
        } else if (currentScrollPos >= 0) {
          $('.logo').css('transform', 'scale(' + scaleto + ')');
          $('.logo').removeClass('black');
          $('.logo').removeClass('hide');
        }
      }

      // if not on title card

      else {
        if ((currentScrollPos > prevScrollPos) && currentScrollPos >= 0) {
          $('.logo').addClass('hide');
        } else if (currentScrollPos >= 0) {
          $('.logo').removeClass('hide');
          $('.logo').addClass('black');
        }
      }

      prevScrollPos = currentScrollPos;
      if (prevScrollPos < 0) {
        prevScrollPos = 0;
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js